module.exports = __webpack_public_path__ + "img/integrador_de_dados_img2.fa9e0109.jpg";